import React from "react";
import HistoricLineChart from "./HistoricLineChart";
import { parseNumber } from "src/lib/historyChart";

// The history cron stores "0.0 V" while a device is offline: not a real reading, so it is a gap
const parseVoltage = (text) => {
  const v = parseNumber(text);
  return v !== null && v > 0 ? v : null;
};

export default function BatteryVoltage(props) {
  return (
    <HistoricLineChart
      title="Battery Voltage Historic Graph"
      subject="battery voltage"
      history={props.historicBatteryVoltages}
      parse={parseVoltage}
      kind="numeric"
      unit="V"
      yLabel="Voltage (V)"
      startDate={props.startDate}
      endDate={props.endDate}
    />
  );
}
